import React from 'react'

import {setMetatags} from '../../modules/metatag_functions.js'

//import img from '../../images/dieetclub-leefstijl-afvallen-recepten-gewoontes.jpg';
//import img from '../../images/dieetclub-leefstijl-afvallen-recepten-gewoontes-fitness.jpg';
import polymedia_png from './polymedia-peter-van-der-meer-black.png';
import usp_tracking from '../../images/dieetclub-club-site-gewicht-bijhouden.jpg';
import usp_plans from '../../images/dieetclub-app-voorbeeld-geef-jezelf-een-doel.jpg';
import usp_diary from '../../images/dieetclub-dagboek-vooruitgang-gewoontes-sport.jpg';
import usp_food from '../../images/dieetclub-voeding-registreren-mobiel-website-eetregistratie.jpg';

import StartBlogs from './StartBlogs.js';
//import StartRecipes from './StartRecipes.js';

import Pricing from './Pricing.js';


export default class extends React.Component {

  render() {
    setMetatags("Start vandaag", null, null, null, "/start");
    return (
      <div>

        <Pricing openModal={(modal_content) => this.props.openModal(modal_content)} />

        <div className="full big accent">
          <div className="wrap content-block">
              <div className="col-2"><img src={polymedia_png} alt="dex.polymedia.nl | who is polymedia.nl" className="screenshot" style={{margin:"0"}} /></div>
              <div className="col-2">
                <h1 style={{margin:"1rem 0", textAlign:"center"}}>Wie is Polymedia?</h1>
                <p style={{fontSize:"20px", textAlign:"left", marginTop:"0"}}>Polymedia bestaat uit Peter van der Meer, een ervaren software-ontwikkelaar, en iemand die al sinds zijn tienerjaren last heeft van overgewicht.<br/><br/><span style={{fontWeight:"bold", fontSize:"150%"}}>&#8220;</span>Na meer dan vijf jaar ontwikkeling aan Extensies voor Twitch, heb ik me gerealiseerd dat ik me wil concentreren op applicaties waarbij ik de volledige controle heb. Met mijn doel om af te vallen was ik op zoek naar groepen waar ik in gesloten kring kon delen hoe het met mijn voortgang gaat, maar ik kon dit eigenlijk niet vinden. Met mijn professionele en hobby-matige werkervaring binnen software bedacht ik me om hier zelf een gesloten platform voor te ontwikkelen.<span style={{fontWeight:"bold", fontSize:"150%", lineHeight:"1"}}>&#8221;</span></p>
                <div className="socials"><a href="https://www.linkedin.com/in/peterdotplus/" target="_blank" rel="noopener noreferrer" style={{marginRight:"42px"}}>LinkedIn</a><a href="https://x.com/PolymediaNL" target="_blank" rel="noopener noreferrer">Twitter</a></div>
              </div>
          </div>
        </div>

        <div className="full big green">
          <div className="wrap content-block">
            <div className="col-2"><img src={usp_tracking} alt="Dieet.Club | Hou je gewicht bij" className="screenshot" style={{margin:"0"}} /></div>
            <div className="col-2"><h2>Hou je gewicht bij</h2></div>
          </div>
        </div>

        <div className="full big green2">
          <div className="wrap content-block">
            <div className="col-2"><h2>Geef jezelf een doel</h2></div>
            <div className="col-2"><img src={usp_plans} alt="Dieet.Club | Geef jezelf een doel" className="screenshot" style={{margin:"0"}} /></div>
          </div>
        </div>

        <div className="full big green">
          <div className="wrap content-block">
            <div className="col-2"><img src={usp_diary} alt="Dieet.Club | Gebruik een eigen dagboek" className="screenshot" style={{margin:"0"}} /></div>
            <div className="col-2"><h2>Schrijf jouw eigen blogs</h2></div>
          </div>
        </div>

        <div className="full big green2">
          <div className="wrap content-block">
            <div className="col-2"><h2>Deel jouw heerlijke recepten</h2></div>
            <div className="col-2"><img src={usp_food} alt="Dieet.Club | Registreer al je voeding" className="screenshot" style={{margin:"0"}} /></div>
          </div>
        </div>

        {/* todo: buttons vervangen voor links <div className="full big greyish">
          <div className="wrap content-block">
            <h2>Recepten</h2>
            <StartRecipes />
            <div style={{textAlign:"center"}}><button onClick={() => {document.getElementById("main").scrollIntoView(true);this.props.push("/recepten")}} className="btn btn-e btn-fat">Meer Recepten</button></div>
          </div>
        </div>*/}

        <div className="full big greyish">
          <div className="wrap content-block">
            <h2>Blogs</h2>
            <StartBlogs />
            <div style={{textAlign:"center"}}><button onClick={() => {document.getElementById("main").scrollIntoView(true);this.props.push("/blogs")}} className="btn btn-e btn-fat">Meer Blogs</button></div>
          </div>
        </div>

        {/*<div className="full big green2">
          <div className="container">
            <div className="card">
              <h1>Dieet.Club is een handige website waarbij je..</h1>
              <h2>De website staat boordevol informatie en motivatie om gezonder te eten, en om af te vallen of op gewicht te blijven.</h2>
            </div>
          </div>
        </div>*/}

        {/*<div className="full big accent">
          <div className="container content-txt">
            <h1>Voel je beter</h1>
            <h2>Al meer dan 4.726 mensen hebben een account aangemaakt! Doe je mee?</h2>
          </div>
        </div>*/}

        {/*<div className="full big green">
          <div className="container content-txt">
            <h1>Wat eten we vandaag?</h1>
            <h1>Hou jij je gewicht bij?</h1>
            <h1>Beleef het voordeel van één app!</h1>
            <h1>Gezondere keuzes voor een gezonder jij.</h1>
            <h1>Ontdek Dieet Club</h1>
            <h1>Voel je beter</h1>
            <h1>Leef gezonder</h1>
            <h1>Blijven jouw corona-kilo's zitten?</h1>
            <h1>Geef jezelf een doel, ontdek DieetClub</h1>
            <h1>Het kan altijd beter!</h1>
            <h1>Snel weer terug naar normaal!</h1>
            <h1>Blijf jij met corona-kilo's zitten?</h1>
          </div>
        </div>

        <div className="full big green">
          <div className="container content-txt">
            <h1>fear-based ads</h1>
            <h2>heb jij al een plan?</h2>
            <h2>heb je wel écht een plan?</h2>
            <h2>wat is jouw doel?</h2>
            <h2>wat is jouw doel voor December? (en dan juist in contrast met een dikke buik bijvoorbeeld)</h2>
            <h2>een droom zonder plan blijft altijd een droom</h2>
            <h2>heb jij wel een plan?</h2>
            <h2>mss iets met gemiddeldes? dus een voorbeeld-plan met "huidig gewicht: gemiddelde vrouw +10kg" etc</h2>
          </div>
        </div>*/}

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/StartPages/Start.js